$("#clbtn").click(function(){
    $(".mobile-nav-wrapper").addClass("cusmenu");
    $(".mobile-nav-wrapper").removeClass("cusmenu2");
    $(this).addClass("d-none");
  });
  $("#bt90").click(function(){
    $(".overlay51").toggleClass("oversh1");
    $(".mobile-nav-wrapper").removeClass("cusmenu");
    $(".mobile-nav-wrapper").addClass("cusmenu2");
    $("#clbtn").removeClass("d-none");
  });
  
  jQuery(".mobile-nav--close>.icon-close2").click(function(){
    jQuery(".overlay51").removeClass("oversh1");
  });


  $(document).ready(function() {
    $('.pagination>li>a').each(function() {
        if ($(this).prop('href') == window.location.href) {
            $(this).toggleClass('selected');
        }
    });
});







$('.fthead h4').on("click", function () {
    $(this).next('ul').slideToggle(500);   
  }); 